exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_addRefreshButtons__2EBDl{margin-top:1rem}", ""]);

// exports
exports.locals = {
	"addRefreshButtons": "style_addRefreshButtons__2EBDl"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/form/SelectWithAddRefresh/style.less
// module id = 1966
// module chunks = 8